import React, { Fragment, useContext, useState } from 'react';
import { Col, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import ChatAppContext from '../../../Context/Chat';
import { CALL, STATUS, PROFILE } from '../../../Constant';
import UserProfile from './UserProfile';
import PeopleListAndStatus from './PeopleListAndStatus';
import PeopleList from './PeopleList';

const ChatMenu = () => {
  const { sidebarToggle } = useContext(ChatAppContext);
  const [activeTab, setActiveTab] = useState('1');
  return (
    <Fragment>
      {sidebarToggle && (
        <Col className='chat-menu show' style={{ opacity: 1, visibility: 'visible' }}>
          <Nav tabs className='border-tab nav-primary'>
            <NavItem id='myTab' role='tablist'>
              <NavLink id='profile-info-tab' tag='a' className={activeTab === '1' ? 'active' : ''} onClick={() => setActiveTab('1')} style={{ cursor: 'pointer' }}>
                {CALL}
              </NavLink>
            </NavItem>
            <NavItem id='myTab' role='tablist'>
              <NavLink id='profile-info-tab' tag='a' className={activeTab === '2' ? 'active' : ''} onClick={() => setActiveTab('2')} style={{ cursor: 'pointer' }}>
                {STATUS}
              </NavLink>
            </NavItem>
            <NavItem id='myTab' role='tablist'>
              <NavLink id='profile-info-tab' tag='a' className={activeTab === '3' ? 'active' : ''} onClick={() => setActiveTab('3')} style={{ cursor: 'pointer' }}>
                {PROFILE}
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId='1'>
              <PeopleList />
            </TabPane>
            <TabPane tabId='2'>
              <PeopleListAndStatus />
            </TabPane>
            <TabPane tabId='3'>
              <UserProfile />
            </TabPane>
          </TabContent>
        </Col>
      )}
    </Fragment>
  );
};
export default ChatMenu;
